
<template>
    <div class="invitation-page">
        <v-container class="text-xs-center invitation-wrapper">
            <v-dialog v-model="dialog_new_provider" max-width="700px" persistent>
                <v-form v-on:submit.prevent="createProviderFromInvitation()">
                    <v-card class="elevation-5">
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>Nuevo transportista</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn color="red" icon @click="dialog_new_provider = false">
                                <v-icon>close</v-icon>
                            </v-btn>
                        </v-toolbar>

                        <v-card-text class="pt-3">
                            <!-- Datos personales -->
                            <v-subheader class="primary--text font-weight-bold pl-0">
                                <v-icon small class="mr-2" color="primary">person</v-icon>
                                Datos personales
                            </v-subheader>
                            <v-divider class="mb-3"></v-divider>
                            <v-layout row wrap>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                        class="px-2"
                                        autofocus
                                        v-model="newProvider.first_name"
                                        prepend-icon="person"
                                        label="Nombre *"
                                        :error-messages="newProviderErrors.first_name"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                        class="px-2"
                                        v-model="newProvider.last_name"
                                        prepend-icon="person_outline"
                                        label="Apellido *"
                                        :error-messages="newProviderErrors.last_name"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                        class="px-2"
                                        v-model="newProvider.telephone"
                                        prepend-icon="phone"
                                        label="Teléfono"
                                        :error-messages="newProviderErrors.telephone"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                        class="px-2"
                                        v-model="newProvider.email"
                                        prepend-icon="email"
                                        label="E-Mail"
                                        :error-messages="newProviderErrors.email"
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>

                            <!-- Datos del vehículo -->
                            <v-subheader class="primary--text font-weight-bold pl-0 mt-2">
                                <v-icon small class="mr-2" color="primary">local_shipping</v-icon>
                                Datos del vehículo
                            </v-subheader>
                            <v-divider class="mb-3"></v-divider>
                            <v-layout row wrap>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                        class="px-2"
                                        v-model="newProvider.plates"
                                        prepend-icon="directions_car"
                                        label="Placas *"
                                        :error-messages="newProviderErrors.plates"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                        class="px-2"
                                        v-model="newProvider.unit_specs"
                                        prepend-icon="local_shipping"
                                        label="Especificaciones de unidad"
                                        :error-messages="newProviderErrors.unit_specs"
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>

                            <!-- Identificación INE -->
                            <v-subheader class="primary--text font-weight-bold pl-0 mt-2">
                                <v-icon small class="mr-2" color="primary">badge</v-icon>
                                Identificación Oficial
                            </v-subheader>
                            <v-divider class="mb-3"></v-divider>
                            <input
                                ref="newProviderIneInput"
                                type="file"
                                accept="image/*"
                                style="display:none"
                                @change="onInePickedNewProvider"
                            />
                            <v-layout row wrap align-center>
                                <v-flex xs12 sm7>
                                    <div
                                        v-if="!newProviderInePreview"
                                        class="inv-ine-upload-zone"
                                        @click="pickIneNewProvider"
                                    >
                                        <v-icon size="36" color="primary lighten-1">add_photo_alternate</v-icon>
                                        <div class="body-2 primary--text mt-1">Seleccionar imagen de identificación oficial</div>
                                        <div class="caption grey--text">Haz clic para buscar el archivo</div>
                                    </div>
                                    <div v-else class="inv-ine-preview-card" @click="pickIneNewProvider">
                                        <v-img :src="newProviderInePreview" max-height="160" contain class="inv-ine-preview-img"></v-img>
                                        <div class="inv-ine-preview-overlay">
                                            <v-icon color="white" size="24">edit</v-icon>
                                            <span class="caption white--text ml-1">Cambiar imagen</span>
                                        </div>
                                    </div>
                                    <div v-if="newProviderErrors.ine" class="error--text caption mt-1">{{ newProviderErrors.ine }}</div>
                                </v-flex>
                                <v-flex xs12 sm5 class="pl-3">
                                    <div class="caption grey--text text--darken-2">
                                        <v-icon small class="mr-1">info</v-icon>
                                        Foto del frente de la identificación oficial del transportista.
                                    </div>
                                    <v-btn v-if="newProviderInePreview" small flat color="grey darken-1" class="mt-2" @click="() => { newProviderInePreview = ''; newProviderIneName = ''; newProvider.ine = null }">
                                        <v-icon left small>delete_outline</v-icon>
                                        Limpiar
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                        </v-card-text>

                        <v-divider></v-divider>
                        <v-card-actions class="px-4 py-3">
                            <v-btn flat color="grey darken-1" @click="dialog_new_provider = false">
                                <v-icon left>cancel</v-icon>
                                {{ $t('cerrar') }}
                            </v-btn>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" type="submit" :loading="loading_create_provider">
                                <v-icon left>person_add</v-icon>
                                {{ $t('agregar') }}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
            <v-dialog
                    v-model="dialog_bloqueo"
                    persistent
                    width="500"
            >
                <v-card class="elevation-0">
                    <v-toolbar class="mb-0" dark color="warning">
                        <v-toolbar-title>
                            {{$t('aviso')}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                        <v-layout align-center justify-center>
                            <h2>{{$t('pagina_caduca')}}</h2>
                            <v-btn
                                    color="primary"
                                    large
                                    to="/home"
                            >
                                <v-icon left>home</v-icon>
                                {{$t('inicio')}}
                            </v-btn>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-dialog
                    v-model="dialog_sin_permisos"
                    persistent
                    width="500"
            >
                <v-card class="elevation-0">
                    <v-toolbar class="mb-0" dark color="warning">
                        <v-toolbar-title>
                            {{$t('aviso')}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                        <v-layout align-center justify-center>
                            <h2>{{$t('sin_permisos')}}</h2>
                            <v-btn
                                    color="primary"
                                    large
                                    to="/home"
                            >
                                <v-icon left>home</v-icon>
                                {{$t('inicio')}}
                            </v-btn>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-layout row wrap>
                <v-flex md12>
                    <v-card class="elevation-2 invitation-card">
                        <v-toolbar class="mb-1" dark color="primary">
                            <v-toolbar-title>
                                Datos de la Invitación
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-card-text class="pb-0">
                            <v-layout row wrap align-center class="company-hero">
                                <v-flex xs12 sm4 class="company-hero-logo-col">
                                    <div class="company-logo-frame">
                                        <v-img
                                            v-if="hostCompanyLogo"
                                            class="centrado"
                                            :src="hostCompanyLogo"
                                            height="140"
                                            contain
                                        ></v-img>
                                        <div v-else class="logo-fallback d-flex align-center justify-center">
                                            <v-icon color="primary" size="52">business</v-icon>
                                        </div>
                                    </div>
                                </v-flex>
                                <v-flex xs12 sm8 class="company-hero-info-col">
                                    <div class="display-hero-title primary--text">{{ info.company_name || 'Empresa anfitriona' }}</div>
                                    <div class="subheading grey--text text--darken-1 mb-3">Invitación de estacionamiento</div>
                                    <div>
                                        <v-chip small color="primary" text-color="white" class="mr-2">
                                            <v-icon left small>local_parking</v-icon>
                                            Espacios: {{ (info.pre_selected_spaces || []).length }}
                                        </v-chip>
                                        <v-chip small outline color="primary">
                                            <v-icon left small>local_shipping</v-icon>
                                            Seleccionados: {{ selectedProvidersCount }}
                                        </v-chip>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                        <v-card-text>
                            <v-form
                                    class="mb-4"
                                    @submit.prevent="create_invt_empresarial()">

                                <!-- SECCIÓN: Detalles de la invitación -->
                                <v-subheader class="primary--text font-weight-bold pl-0">
                                    <v-icon small class="mr-2" color="primary">event_note</v-icon>
                                    Detalles de la invitación
                                </v-subheader>
                                <v-divider class="mb-2"></v-divider>
                                <table class="inv-details-table">
                                    <tbody>
                                        <tr>
                                            <td class="inv-dt-label">
                                                <v-icon small color="primary" class="mr-1">business</v-icon>
                                                {{ $t('lbl_host_company') }}
                                            </td>
                                            <td class="inv-dt-value">{{ info.company_name }}</td>
                                        </tr>
                                        <tr>
                                            <td class="inv-dt-label">
                                                <v-icon small color="primary" class="mr-1">person</v-icon>
                                                {{ $t('Anfitrion') }}
                                            </td>
                                            <td class="inv-dt-value">{{ info !== '' ? info.host_name : '' }}</td>
                                        </tr>
                                        <tr>
                                            <td class="inv-dt-label">
                                                <v-icon small color="primary" class="mr-1">today</v-icon>
                                                {{ $t('fecha_inv') }}
                                            </td>
                                            <td class="inv-dt-value">{{ info !== '' ? info.invitation_date.split('-').join('/') : '' }}</td>
                                        </tr>
                                        <tr>
                                            <td class="inv-dt-label">
                                                <v-icon small color="primary" class="mr-1">event_busy</v-icon>
                                                {{ $t('fecha_expiracion') }}
                                            </td>
                                            <td class="inv-dt-value">{{ info.expiration ? info.expiration.split('-').join('/') : '' }}</td>
                                        </tr>
                                        <tr>
                                            <td class="inv-dt-label">
                                                <v-icon small color="primary" class="mr-1">schedule</v-icon>
                                                Horario
                                            </td>
                                            <td class="inv-dt-value">{{ formatInvitationTimeRange(info) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="inv-dt-label">
                                                <v-icon small color="primary" class="mr-1">subject</v-icon>
                                                {{ $t('Asunto') }}
                                            </td>
                                            <td class="inv-dt-value">{{ info.subject }}</td>
                                        </tr>
                                        <tr v-if="info.notes">
                                            <td class="inv-dt-label">
                                                <v-icon small color="primary" class="mr-1">notes</v-icon>
                                                {{ $t('Notas') }}
                                            </td>
                                            <td class="inv-dt-value">{{ info.notes }}</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <!-- SECCIÓN: Espacios asignados -->
                                <v-subheader class="primary--text font-weight-bold pl-0 mt-3">
                                    <v-icon small class="mr-2" color="primary">local_parking</v-icon>
                                    {{ $t('assigned_parking_spaces') }}
                                </v-subheader>
                                <v-divider class="mb-3"></v-divider>
                                <div class="px-2 pb-3">
                                    <v-chip
                                        v-for="space in info.pre_selected_spaces"
                                        :key="space.id"
                                        color="primary"
                                        outline
                                        small
                                        class="mr-2 mb-2"
                                    >
                                        <v-icon left small>local_parking</v-icon>
                                        {{ space.space_number }} — {{ space.space_type || 'N/A' }}
                                    </v-chip>
                                    <div v-if="!info.pre_selected_spaces || info.pre_selected_spaces.length === 0" class="caption grey--text">Sin espacios asignados.</div>
                                </div>

                                <!-- SECCIÓN: Selección de transportistas -->
                                <v-subheader class="primary--text font-weight-bold pl-0 mt-3">
                                    <v-icon small class="mr-2" color="primary">local_shipping</v-icon>
                                    Transportistas
                                </v-subheader>
                                <v-divider class="mb-3"></v-divider>
                                <v-autocomplete
                                    v-model="selectedProviders"
                                    prepend-icon="person"
                                    name="selectedProviders"
                                    :item-text="providerDisplay"
                                    item-value="id"
                                    label="Selecciona los transportistas"
                                    :filter="customFilter"
                                    :error-messages="errores.guests"
                                    :items="providers"
                                    :no-data-text="$t('no_resultados')"
                                    clearable
                                    chips
                                    multiple
                                    return-object
                                ></v-autocomplete>
                                <v-alert
                                    v-if="providers.length === 0"
                                    type="info"
                                    :value="true"
                                    class="mt-2 mb-3"
                                    outline
                                >
                                    No hay transportistas en tu catálogo. Puedes crear uno con el botón de abajo.
                                </v-alert>
                                <v-layout justify-end class="mt-1 mb-4">
                                    <v-btn small outline color="primary" @click="openNewProviderDialog">
                                        <v-icon left small>add</v-icon>
                                        Nuevo transportista
                                    </v-btn>
                                </v-layout>

                                <v-divider class="mb-3"></v-divider>
                                <v-layout justify-end>
                                    <v-btn
                                        color="primary"
                                        :loading="loading_send"
                                        :disabled="!canSubmitInvitation"
                                        @click="create_invt_empresarial()"
                                    >
                                        <v-icon left>send</v-icon>
                                        {{ $t('enviar') }}
                                    </v-btn>
                                </v-layout>
                            </v-form>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import '@/plugins/axios'
    import store from '@/store'
    import Vue from 'vue'
    import VeeValidate from 'vee-validate'
    import {mapGetters, mapState} from 'vuex'
// import { info } from 'node-sass'

    Vue.use(VeeValidate)

    export default {
        name: "form_parking_invitation_data",
        data () {
            return {
                rules: {
                    required: value => !!value || 'Campo Requerido',
                    counter: value => value.length >= 10 || 'El Número de Celular debe de contener 10 dígitos',
                    number: value => {
                        const pattern = /^\d+$/
                        return pattern.test(value) || 'Ingresa un Campo Númerico.'
                    },
                    email: value => {
                        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                        return pattern.test(value) || 'Dirección E-Mail no Válida.'
                    },
                },
                info: '',
                vehicle: '',
                notes: '',
                cellphone: '',
                email: '',
                errores: [],
                dialog_bloqueo: false,
                dialog_sin_permisos: false,
                dialog_new_provider: false,
                celular_nuevo: '',
                entries: [],
                isLoading: false,
                search: null,
                loading_send: false,
                loading_create_provider: false,
                today: '',
                providers: [],
                selectedProviders: [],
                newProvider: {
                    idEmpresa: null,
                    first_name: '',
                    last_name: '',
                    telephone: '',
                    email: '',
                    ine: null,
                    plates: '',
                    unit_specs: ''
                },
                newProviderErrors: {},
                newProviderIneName: '',
                newProviderInePreview: ''
            }
        },
        computed: {
            ...mapGetters(['getProfile']),
            ...mapState(['language']),
            selectedProvidersCount() {
                return Array.isArray(this.selectedProviders) ? this.selectedProviders.length : 0
            },
            canSubmitInvitation() {
                return this.selectedProvidersCount > 0 && !this.loading_send
            },
            hostCompanyLogo() {
                if (!this.info || typeof this.info !== 'object') return ''
                return this.info.company_logo || this.info.logoEmpresa || this.info.logo || ''
            }
        },
        watch: {
            isUpdating (val) {
                if (val) {
                    setTimeout(() => (this.isUpdating = false), 3000)
                }
            },
            search (val) {
                if (!val) return
            }
        },
        created: function(){
            this.get_info_invit_empresarial()
            this.getProvidersCatalog()
        },
        methods:{
            normalizeApiTime(timeStr) {
                if (!timeStr || typeof timeStr !== 'string') return ''
                return timeStr.split(':').slice(0, 2).join(':')
            },
            formatInvitationTimeRange(invitationInfo) {
                const startTime = this.normalizeApiTime(invitationInfo && invitationInfo.start_time)
                const endTime = this.normalizeApiTime(invitationInfo && invitationInfo.end_time)
                if (startTime && endTime) return `${startTime} - ${endTime}`
                return startTime || endTime || 'Todo el dia'
            },
            getProvidersCatalog: function(){
                const params = {}
                if (this.getProfile && this.getProfile.id_company) {
                    params.idEmpresa = this.getProfile.id_company
                }
                const config = {
                method: 'get',
                url: 'https://empresa-service.intrare.app/Parking/providers/',
                headers: {
                'Content-Type': 'application/json',
                'authorization': 'Token ' + store.getters.getToken
                },
                params
            };
            axios(config)
                .then(response => {
                    this.providers = Array.isArray(response.data) ? response.data : []
                    console.log(this.providers)
                })
                .catch(error => {
                    console.log(error)
                })

            },
            customFilter (item, queryText) {
                const textOne = (item.first_name || '').toLowerCase()
                const textTwo = (item.last_name || '').toLowerCase()
                const textThree = (item.telephone || '').toLowerCase()
                const textFour = (item.plates || '').toLowerCase()
                const searchText = queryText.toLowerCase()
                return textOne.indexOf(searchText) > -1
                    || textTwo.indexOf(searchText) > -1
                    || textThree.indexOf(searchText) > -1
                    || textFour.indexOf(searchText) > -1
            },
            providerDisplay: item => {
                const fullName = ((item.first_name || '') + ' ' + (item.last_name || '')).trim()
                return fullName + ' - ' + (item.telephone || '-')
            },
            openNewProviderDialog() {
                this.resetNewProviderForm()
                this.dialog_new_provider = true
            },
            resetNewProviderForm() {
                this.newProvider = {
                    idEmpresa: this.getProfile && this.getProfile.id_company ? this.getProfile.id_company : null,
                    first_name: '',
                    last_name: '',
                    telephone: '',
                    email: '',
                    ine: null,
                    plates: '',
                    unit_specs: ''
                }
                this.newProviderErrors = {}
                this.newProviderIneName = ''
                this.newProviderInePreview = ''
                if (this.$refs.newProviderIneInput) {
                    this.$refs.newProviderIneInput.value = ''
                }
            },
            pickIneNewProvider() {
                if (this.$refs.newProviderIneInput) {
                    this.$refs.newProviderIneInput.click()
                }
            },
            onInePickedNewProvider(event) {
                const files = event.target.files
                if (!files || !files[0]) {
                    return
                }
                const file = files[0]
                this.newProvider.ine = file
                this.newProviderIneName = file.name

                const fr = new FileReader()
                fr.readAsDataURL(file)
                fr.addEventListener('load', () => {
                    this.newProviderInePreview = fr.result
                })
            },
            createProviderFromInvitation() {
                this.loading_create_provider = true
                this.newProviderErrors = {}

                const bodyFormData = new FormData()
                if (this.getProfile && this.getProfile.id_company) {
                    bodyFormData.set('idEmpresa', this.getProfile.id_company)
                }
                bodyFormData.set('first_name', this.newProvider.first_name)
                bodyFormData.set('last_name', this.newProvider.last_name)
                bodyFormData.set('telephone', this.newProvider.telephone)
                bodyFormData.set('email', this.newProvider.email)
                bodyFormData.set('plates', this.newProvider.plates)
                bodyFormData.set('unit_specs', this.newProvider.unit_specs)
                if (this.newProvider.ine) {
                    bodyFormData.append('ine', this.newProvider.ine)
                }

                const config = {
                    method: 'post',
                    url: 'https://empresa-service.intrare.app/Parking/providers/',
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: bodyFormData
                }

                axios(config)
                    .then(response => {
                        const newProvider = response.data || {}
                        this.providers.push(newProvider)
                        this.selectedProviders.push(newProvider)
                        this.dialog_new_provider = false
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', 'Transportista creado correctamente.')
                    })
                    .catch(error => {
                        if (error.response && error.response.status === 400 && error.response.data) {
                            this.newProviderErrors = error.response.data
                        }
                    })
                    .finally(() => {
                        this.loading_create_provider = false
                    })
            },
            get_info_invit_empresarial(){
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/Parking/invitations/referred/' + this.$route.params['token'] + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        console.log(response.data)
                        this.info = response.data
                    })
                    .catch(error => {
                        if(error.response.status == 404)
                            this.dialog_bloqueo = true
                        console.log(error)
                    })
            },
            get_current_date(){
                var today = new Date();
                var dd = today.getDate();
                var mm = today.getMonth()+1;
                var yyyy = today.getFullYear();

                if(dd<10)
                {
                    dd='0'+dd
                }

                if(mm<10)
                {
                    mm='0'+mm
                }
                this.today = yyyy + '-' + mm + '-' + dd
            },
            create_invt_empresarial(){
                if (!this.canSubmitInvitation) {
                    this.errores = { guests: ['Selecciona al menos un transportista.'] }
                    return
                }
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.loading_send = true
                        this.errores = []
                        this.get_current_date()
                                                console.log('this.selectedProviders = ', this.selectedProviders)
                        var guests = []
                                                if (this.selectedProviders !== null  && this.selectedProviders !== undefined && this.selectedProviders !== '' && this.selectedProviders.length > 0) {
                            guests = []
                                                        for(let i = 0; i < this.selectedProviders.length; i++) {
                                                            const provider = this.selectedProviders[i]
                                                            guests.push({
                                                                provider_id: provider.id || provider.provider_id,
                                                                first_name: provider.first_name,
                                                                last_name: provider.last_name,
                                                                email: provider.email || '',
                                                                phone: provider.telephone || provider.phone || provider.celular || ''
                                                            })
                            }
                        }
                                                console.log('AUTOCOMPLETE = ', this.selectedProviders)
                                                const payload = {
                                                        referred_invitation_id: this.info.id,
                                                        guests: guests
                                                }
                                                if (this.getProfile && this.getProfile.company_name) {
                                                        payload.empresa_from = this.getProfile.company_name
                                                }
                                                if (this.notes) {
                                                        payload.notes = this.notes
                                                }
                        const config = {
                            method: 'post',
                            url: 'https://empresa-service.intrare.app/Parking/invitations/enterprise/create/',
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept-Language': this.language ,
                                'authorization': 'Token ' + store.getters.getToken
                            },
                            data: payload
                        };
                        axios(config)
                            .then(ok => {
                                console.log('Invitación Creada Correctamente.')
                                this.$store.commit('snackbar_activate_true')
                                this.$store.commit('snackbar_change_message', this.$t('mensaje_invitacion_alta'))
                                this.loading_send = false
                                this.$router.push({path: '/'})
                                // setTimeout(this.clear, 3000);
                            })
                            .catch(error => {
                                if(error.response.status == 400
                                    && typeof error.response.data == "object"
                                    && error.response.data)
                                    this.errores = error.response.data
                                if(error.response.status == 403)
                                    this.dialog_sin_permisos = true
                                this.loading_send = false
                            })
                    }
                }).catch((e) => {
                    console.log(e);// Failed
                    this.loading_send = false
                });
            },
        }
    }
</script>

<style scoped>
    .invitation-page {
        background: linear-gradient(180deg, #f4f7fb 0%, #ffffff 100%);
        min-height: 100%;
    }

    .invitation-wrapper {
        max-width: 1150px;
    }

    .invitation-card {
        border-radius: 12px;
        overflow: hidden;
    }

    .company-hero {
        background: linear-gradient(135deg, rgba(0, 43, 72, 0.06) 0%, rgba(25, 118, 210, 0.08) 100%);
        border: 1px solid rgba(25, 118, 210, 0.15);
        border-radius: 12px;
        padding: 16px 20px;
    }

    .company-hero-logo-col {
        padding: 8px 16px 8px 8px;
    }

    .company-hero-info-col {
        padding: 8px 8px 8px 20px;
        border-left: 2px solid rgba(25, 118, 210, 0.18);
    }

    @media (max-width: 599px) {
        .company-hero-info-col {
            border-left: none;
            border-top: 2px solid rgba(25, 118, 210, 0.18);
            padding: 16px 8px 8px 8px;
            text-align: center;
        }
    }

    .display-hero-title {
        font-size: 1.35rem;
        font-weight: 700;
        line-height: 1.3;
        margin-bottom: 4px;
    }

    .company-logo-frame {
        background: #ffffff;
        border: 1px solid #e5edf5;
        border-radius: 10px;
        padding: 12px;
        min-height: 164px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .logo-fallback {
        min-height: 140px;
        width: 100%;
        background: #f7fbff;
        border-radius: 8px;
    }

    /* Aligned details table */
    .inv-details-table {
        width: 100%;
        border-collapse: collapse;
        margin-bottom: 8px;
    }
    .inv-dt-label {
        width: 42%;
        padding: 7px 12px 7px 4px;
        vertical-align: middle;
        font-size: 0.82rem;
        color: #616161;
        white-space: nowrap;
    }
    .inv-dt-value {
        padding: 7px 4px;
        vertical-align: middle;
        font-size: 0.9rem;
        color: #212121;
        font-weight: 500;
    }
    .inv-details-table tbody tr:nth-child(even) {
        background: rgba(25, 118, 210, 0.04);
    }

    .centrado{
        display:block;
        margin-left: auto;
        margin-right: auto;
    }

    /* INE upload zone (dialog nuevo transportista) */
    .inv-ine-upload-zone {
        border: 2px dashed #1976d2;
        border-radius: 8px;
        padding: 24px 16px;
        text-align: center;
        cursor: pointer;
        background: #f5f8ff;
        transition: background 0.2s;
    }
    .inv-ine-upload-zone:hover {
        background: #e8f0fe;
    }
    .inv-ine-preview-card {
        position: relative;
        border: 2px solid #1976d2;
        border-radius: 8px;
        overflow: hidden;
        cursor: pointer;
    }
    .inv-ine-preview-overlay {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(25, 118, 210, 0.72);
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 5px;
        opacity: 0;
        transition: opacity 0.2s;
    }
    .inv-ine-preview-card:hover .inv-ine-preview-overlay {
        opacity: 1;
    }
</style>
